<template>
  <div>
    <b-container fluid class="tw-mb-5 tw-bg-gray-100 tw-border tw-border-blue-200" style="padding-bottom: 10px;">
       <!-- pull down menu -->
      <b-row class="tw-mt-2" style="margin-top: 1em; margin-bottom: 0em; margin-left: 0.2em">
        <b-col cols="auto">
          <b-button
            @click="handleShowHidePlot"
            size=""
            variant="outline-info"
          >
            {{ isPlotHidden ? "Show all" : "Hide all" }} plots
          </b-button>
        </b-col>
      </b-row>
      <b-row class="tw-mt-2">
        <!-- BEGIN CHART -->
        <b-col md="12" lg="10" :xl="12">
          <line-chart
            :chartData="positiveInfections.chartdata"
            :options="positiveInfections.options"
            :styles="positiveInfections.myStyles"
            :key="componentKey"
          >
          </line-chart>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import LineChart from "@/components/charts/LineChart.vue";

export default {
  mixins: [],
  components: {
    LineChart,
  },
  props: {},
  data() {
    return {
      // used to re-render chart component
      componentKey: 0,
      // used to change button text
      isPlotHidden: false,
      // lineplot data and options
      positiveInfections: {
        chartdata: {
          datasets: [],
          labels: []
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top",
            labels: {
              boxWidth: 18,
            },
          },
          title: {
            display: true,
            text: 'Monthly accumulated number of infections'
          },
          scales: {
            xAxes: [{
              position: 'bottom',
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: true,
                labelString: 'year-month'
              }
            }],
            yAxes: [{
              position: 'left',
              gridLines: {
              },
              ticks: {
                // show zero in the y-axis
                beginAtZero: true
              },
              scaleLabel: {
                display: true,
                labelString: 'number of infections'
              }
            }]
          }
        },
        myStyles: {
          height: "30vh",
          width: "100%",
          position: "relative",
        },
      },
    };
  },
  mounted: function() {
    this.get();
  },
  methods: {
    get: function() {
      const that = this;

      // generate random colors
      const randomColor = function(opacity) {
        return 'rgba(' +
          Math.round(Math.random() * 255) + ',' +
          Math.round(Math.random() * 255) + ',' +
          Math.round(Math.random() * 255) + ',' +
          (opacity || '.3') + ')';
      };

      const params = {
        category: 'all',
        lineplot: 'yes'
      }

      // request data: share the API with subject infected details (table)
      HTTP.get("/eavetubes/metrics/subject-infected-details", { params: params })
        .then((response) => {

          // lineplot labels (x-axis ticks)
          that.positiveInfections.chartdata.labels = response.data.lineplot_labels;

          // generate lineplot data
          const infectionDataset = response.data.lineplot_data.map((item) => {
            const label = Object.keys(item)[0];
            const data = Object.values(item)[0];
            const backgroundColor = randomColor(1);
            const borderColor = backgroundColor;
            const pointRadius = 4.5;
            const fill = false;
            const cubicInterpolationMode = 'default';
            const lineTension = 0.4;  // no spline = 0
            const spanGaps = false;

            return {
              label,
              data,
              backgroundColor,
              borderColor,
              pointRadius,
              fill,
              cubicInterpolationMode,
              lineTension,
              spanGaps,
            }
          });

          // update data state
          this.positiveInfections.chartdata.datasets = infectionDataset;

          // update lineplot
          this.componentKey++;

        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });

    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {},
    // hide or show all lineplots
    handleShowHidePlot: function() {
      // change individual data prop
      this.positiveInfections.chartdata.datasets.forEach(dataset => {
        dataset.hidden = !dataset.hidden;
      });
      // change disabled state
      this.isPlotHidden = !this.isPlotHidden;
      // update lineplot
      this.componentKey++;
    },
  },
};
</script>

<style>
</style>
